import baseStyled, { css } from 'styled-components';

type Styled = typeof baseStyled;

export const styled: Styled = 'default' in baseStyled ? (baseStyled.default as Styled) : baseStyled;

export { css };
